import { memo } from "react";

type Props = {
	children: React.ReactNode;
};

export const FormInputLabelWrapper = memo(({ children }: Props) => {
	return <div className="flex flex-col gap-y-1">{children}</div>;
});
